export const bpXSmall = 321;
export const bpSmall = 740;
export const bpSmallPlus = 780;
export const bpMedium = 940;
export const bpLarge = 1024;
export const bpXLarge = 1100;
export const bpXXLarge = 1250;
